import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-query',
  templateUrl: './edit-query.component.html',
  styleUrls: ['./edit-query.component.scss']
})
export class EditQueryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
